<template>
  <div v-if="showPkg || showPromo" class="pkg">
    <template v-if="more">
      <div v-if="showPromo" class="pkg-promo">
        <div bold class="pkg-promo-tile">{{ promoTile }}</div>
        <div
          v-for="(promo, key) in promoList"
          :key="key"
          class="pkg-promo-item"
        >
          <div class="item-count">x{{ promo.count }}</div>
          <div break class="item-info">{{ productName }}</div>
          <div class="item-price">
            <span>{{ $pid(promo.price * promo.count) }}</span>
            <span v-if="!promo.isNormal" class="del">
              {{ $pid(promo.normalPrice * promo.count) }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="showPkg" class="pkg-groups">
        <div class="pkg-groups-item">
          <div class="item-tile">{{ $t('checkout.bundlingItem') }}</div>
          <div class="item-prods">
            <div v-for="it in mainList" :key="it.productId" class="prod">
              <div class="prod-l">
                <div class="prod-count">x{{ it.netQuantity }}</div>
              </div>
              <div class="prod-m">
                <p class="prod-tile">
                  {{ it.productName }}
                </p>
                <p class="prod-subtile">
                  <template v-for="(modif, i) in it.modifiers || []">
                    .{{ modif.name }}
                    {{ i === it.modifiers.length - 1 ? '' : '/' }}
                  </template>
                </p>
                <p v-if="it.comment" class="prod-subtile">
                  {{ it.comment }}
                </p>
              </div>
              <div class="prod-r">
                <div class="prod-price" />
                <!-- 主商品modifier价格 -->
                <!-- <span v-if="sumModifPrice(it) > 0" class="prod-price">
                  {{ $n(sumModifPrice(it), 'currency', 'id-ID') }}
                </span> -->
              </div>
            </div>
          </div>
        </div>
        <div v-for="(item, i) in additional" :key="i" class="pkg-groups-item">
          <div class="item-tile">
            {{ $t('checkout.additional') }} {{ item.groupName }}
          </div>
          <div class="item-prods">
            <div v-for="it in item.items" :key="it.productId" class="prod">
              <div class="prod-l">
                <div class="prod-count">x{{ it.netQuantity }}</div>
              </div>
              <div class="prod-m">
                <p class="prod-tile">{{ it.productName }}</p>
                <p class="prod-subtile">
                  <template v-for="(modif, idx) in it.modifiers || []">
                    .{{ modif.name }}
                    {{ idx === it.modifiers.length - 1 ? '' : '/' }}
                  </template>
                </p>
                <p v-if="it.comment" class="prod-subtile">
                  {{ it.comment }}
                </p>
              </div>
              <div class="prod-r">
                <!-- <span class="prod-price">
                  {{ $n(it.finalPrice * it.netQuantity, 'currency', 'id-ID') }}
                </span> -->
                <!-- <span v-if="sumModifPrice(it) > 0" class="prod-price">
                  {{ $n(sumModifPrice(it), 'currency', 'id-ID') }}
                </span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-if="showSeeBtn" class="pkg-btn" @click="more = !more">
      {{ seeAllText }}
      <q-icon :name="`svg:arrow_${more ? 'up' : 'down'}`" size="18" />
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';
import { use18n } from 'src/utils/v2_helper/common';
import { useProductPrice } from '../../../utils/hooks/product/use-product-price';
import { isPkg } from '../utils';

const props = defineProps({
  product: {
    type: Object,
    default() {
      return {};
    },
  },
});
const { $t } = use18n();
const more = ref(false);

const _prod = computed(() => props.product);
const { price, delPrice, promoTile, showPromo, promoList } =
  useProductPrice(_prod);

const showPkg = computed(() => isPkg(props.product.groupTypeId));
const showSeeBtn = computed(() => {
  if (showPkg.value) return true;
  return showPromo.value;
});
const seeAllText = computed(() => {
  if (more.value) return $t('checkout.hideAllItems');
  if (showPromo.value) return promoTile.value;
  if (showPkg.value) return $t('checkout.seeAllItems');
  return promoTile.value;
});
const productName = computed(() => props.product.productName);
const mainList = computed(() => props.product.baseGroup?.items || []);
const additional = computed(() => {
  const options = props.product.optionGroups || [];
  return options;
});

function sumModifPrice(product) {
  return (
    product.modifiers.reduce((acc, cur) => acc + cur.basePrice, 0) *
    product.netQuantity
  );
}
</script>

<style scoped lang="scss">
p {
  margin: 0;
  word-break: break-word;
}
.toright {
  position: absolute;
  top: 0;
  right: 0;
}
.pkg {
  background: #fff;
  &-promo {
    padding: 16px 0;
    font-size: 12px;
    &-tile {
    }
    &-item {
      display: flex;
      font-weight: bold;
      margin-top: 14px;
      .item-count {
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: $grayBg;
        border-radius: $border-radius-1;
        outline: solid 2px $border-color-3;
        color: $grayFont;
        align-self: flex-start;
      }
      .item-info {
        margin: 0 8px;
        flex: 1;
      }
      .item-price {
        margin-left: auto;
        display: flex;
        flex-direction: column;
        .del {
          font-weight: normal;
          text-decoration: line-through;
        }
      }
    }
  }
  &-groups {
    &-item {
      border-top: solid 1px #e5e7eb;
      padding: 10px 0;
      .item-tile {
        font-size: 12px;
        color: #6b7280;
        margin-bottom: 12px;
      }
      .item-prods {
        .prod {
          position: relative;
          min-height: 35px;
          display: flex;
          & + .prod {
            margin-top: 10px;
          }
          .prod-m {
            flex: 1;
            padding-right: 15px;
          }
          .prod-r {
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            align-items: flex-end;
          }
          &-tile {
            font-size: 14px;
          }
          &-count,
          &-subtile {
            font-size: 12px;
            color: #6b7280;
          }
          &-count {
            font-weight: bold;
            text-align: left;
            width: 20px;
            height: 20px;
            margin-right: 20px;
            line-height: 20px;
            text-align: center;
            background: $grayBg;
            border-radius: $border-radius-1;
            outline: solid 2px $border-color-3;
            color: $grayFont;
            align-self: flex-start;
          }
          &-price {
            font-size: 12px;
          }
        }
      }
    }
  }
  &-btn {
    font-size: 12px;
    color: #6b7280;
    padding: 6px 0;
    width: 100%;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    text-align: center;
    margin-top: 4px;
  }
}
</style>
